import { html, type TemplateResult } from 'lit';

import type { ConfirmView } from '../../types/views';
import type { ReviewValidationSummary } from '../csv-import-validation-summary/csv-import-validation-summary.js';

import './csv-import-confirm-body.js';

// ============================================================================
// Module-level cached event dispatchers
// ============================================================================

const dispatchClose = (e: Event) => {
  const target = e.target as HTMLElement;
  target.dispatchEvent(
    new CustomEvent('csv-import-close', {
      bubbles: true,
      composed: true,
    }),
  );
};

// ============================================================================
// Step template function
// ============================================================================

/**
 * Returns the full step template for the Confirm step: body + footer button.
 * Intended to be rendered inside `<csv-import-modal-shell>`.
 *
 * The confirm step is reached AFTER submission completes. The only action
 * available is Close, which dispatches `csv-import-close`. The orchestrator's
 * `_cancelConfirmView` getter determines whether to show the download-report
 * warning or close immediately (firing `import-done`).
 */
export function confirmStepTemplate(
  view: ConfirmView,
  props: { summary: ReviewValidationSummary },
): TemplateResult {
  return html`
    <csv-import-confirm-body
      slot="step-body"
      .view=${view}
      .summary=${props.summary}
    ></csv-import-confirm-body>
    <inmar-hc-button
      slot="footer"
      label="Close"
      variant="primary"
      @button-click=${dispatchClose}
    ></inmar-hc-button>
  `;
}
